export default class Page {
    constructor(headers,urlParams,user){
        this.headers=headers;
        this.urlParams=urlParams;
        this.user=user;
        this.badgeSlug=0;
    }
    encodeBranch() {
        if(this.urlParams.branch) this.urlParams.branch = window.cleanEncodeURIComponent(this.urlParams.branch)
    }
    processProjectInfo(project){
        const url=this.getBaseUrl(project.url);
        const account = this.getAccountUuid(project.url)
	    project.title = url.replace("github.com/","");
        this.urlParams.branch=!this.urlParams.branch?project.branches[0]:this.urlParams.branch;
        // this.encodeBranch()
        if(!this.user){
            return{
                titleState:{
                    isUserLogged: false,
                    isLinkAvailable: false,
                    isUserUndefined: this.user === undefined,
                    isAccountDefault: this.user === undefined,
                    isAccountOpensource: false,
                    canDownloadPDF: false,
                    hasLicenses: false,
                    isUserAdmin: false,
                    isUserAccountAdmin: false,
                    hasSafeVersion: false,
                    hasSbom: true,
                    canDownloadSbom: true,
                    isPublic: !window.location?.search.includes("mode=eli"),
                    hasSecureCodeWarriorFeature: false,
                    hasChaiFeature: false,
                    hasJiraFeature: false
                },
                accountUuid: account,
                accountInfo: null,
                isUserAccountAdmin: null,
                isExperimental: false
            }
        }

        return{
            titleState: {
                isUserLogged: true,
                isLinkAvailable: false,
                isUserUndefined: false,
                isAccountOpensource: this.user.account.plan.includes("opensource"),
                canDownloadPDF: this.user.account.bundle.limits.usePDFReports,
                isAccountDefault: this.user.account.default,
                hasLicenses: this.user.account.features.includes("licenses"),
                isUserAdmin: this.user.account.sysadmin,
                isUserAccountAdmin: this.user.account.sysadmin || this.user.membership.role==="Administrator" ,
                hasSafeVersion: this.user.account.features.includes("nextsafe"),
                hasSbom: this.user.account.default || this.user.account.features.includes("sbom") || this.user.account.plan.includes("opensource"),
                canDownloadSbom: this.user.account.default || this.user.account.features.includes("advancedsboms"),
                isPublic: !window.location?.search.includes("mode=eli"),
                hasSecureCodeWarriorFeature: this.user && this.user.account && this.user.account.features && this.user.account.features.includes("securecodewarrior"),
                hasChaiFeature: this.user.account.features.includes("chai"),
                hasJiraFeature: this.user.account.features.includes("jira")
            },
            accountUuid: account,
            accountInfo: null,
            isExperimental: this.user.account.properties.experimental && this.user.account.properties.experimental[this.user.membership.uuid]
        }

    }
    projectError(){
        return {errorProject: true}
    }

    getBaseUrl(url){
        url=url.split("?")[0];
        return url.split(":").pop(); 
    }

    getAccountUuid(url){
        url = url.split("account=")[1]
        return url
    }
    

}